export enum ProductModalErrorTypes {
  UnselectedVariant = "unselectedVariants",
  WaitForStreamStartToBuy = "waitForStreamStart",
}

interface UnselectedVariantType {
  type: ProductModalErrorTypes.UnselectedVariant;
  key: string;
}

interface WaitForStreamType {
  type: ProductModalErrorTypes.WaitForStreamStartToBuy;
  key: string;
}

export type ProductModalError = UnselectedVariantType | WaitForStreamType;
export interface ProductModalErrors {
  [key: string]: ProductModalError[];
}
